//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum HeaderLinkIcon {
	None = 0,
	Fire = 1,
	Diamond = 2,
	Percentage = 3,
	Plus = 4,
	Chat = 5,
	Headphones = 6,
	Tag = 7,
	Tree = 8,
	Sun = 9,
	Rx = 10,
	History = 11,
	Mail = 12
}
